import { Component, Vue, } from "vue-property-decorator";
import AIMessageInput from './ai-message-input.js';
import AIChatThread from './ai-chat-thread.js';

import './ai-chat-window.scss';
import { AIChatService } from "./ai-chat.service.js";
import { createMessages } from "./ai-chat.model.js";
import { uuidv4, wait } from "../../../utility/index.js";
import { ClearIcon, DeleteIcon, HistoryIcon, SearchIcon, StopIcon } from "./ai-chat-icons.js";
import { HttpLib } from "../../../services/http/http-lib.js";



@Component({
  name: 'AIChatWindow',
})
export default class AIChatWindow extends Vue {

  messages = [];
  askMessage = '';
  message = '';

  chatEnabled = false;
  historyEnabled = false;
  historyLoading = false;
  historyEnded = false;
  responseLoading = false;

  rowCount = 100;

  newResponseId = uuidv4();
  query = '';

  reset() {
    this.chatEnabled = false;
    this.historyEnabled = false;
    this.historyLoading = false;
    this.historyEnded = false;
    this.responseLoading = false;
    this.messages = [];
    this.newResponseId = uuidv4();
    this.query = '';
  }

  async onChatSend() {
    console.log('onChatSend');
    this.chatEnabled = true;
    this.newResponseId = uuidv4();
    const userMessageId = uuidv4();
    this.messages = [
      ...this.messages,
      {
        id: userMessageId,
        type: "user",
        text: this.message,
        sent: `2020-12-12 12:12:12`,
      },
      {
        id: this.newResponseId,
        type: "chatbot",
        text: ``,
        sent: `2020-12-12 12:12:12`,
        loading: true,
        newResponse: true,
      }];


    wait(100).then(() => {
      const userMessage = document.querySelector(`#ai-message-${userMessageId}`);
      console.log({ 'Focussing': userMessage });
      userMessage?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    });

    this.query = this.message;
    this.message = '';

    // this.responseLoading = true;
    // const aiResponse = await AIChatService.ask(this.query);
    // this.messages = this.messages.map(message => {
    //   if (message.id === this.newResponseId) {
    //     return {
    //       ...message,
    //       loading: false,
    //       text: aiResponse?.data?.message,
    //       sent: new Date().toISOString(),
    //     }
    //   }
    //   return message;
    // });
    // this.responseLoading = false;

    await this.loadResponse();
  }

  get moduleName() {
    console.log({ 'ai-chat-window.js: 95 this.$route': this.$route, m: this.$route?.path?.split('/')?.[2] });
    return this.$route?.path?.split('/')?.[2] || 'booking';
  }

  source = HttpLib.CancelToken.source();


  async loadResponse() {
    this.source = HttpLib.CancelToken.source();

    this.responseLoading = true;
    try {
      const aiResponse = await AIChatService.ask(this.query, this.moduleName, {
        cancelToken: this.source.token,
      });
      // await wait(500);
      this.messages = this.messages.map(message => {
        if (message.id === this.newResponseId) {
          return {
            ...message,
            loading: false,
            text: aiResponse?.message,
            // text: `What is this \n ? Can you please Explain ? <br/> I cant stand it`,
            sent: new Date().toISOString(),
          }
        }
        return message;
      });

      // scrollIntoView the response

      // await wait(3000);
      // const newResponse = document.querySelector(`#ai-message-${this.newResponseId}`);
      // newResponse?.scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      //   inline: 'start',
      // });
      // await wait(500);
      // // Focus on the input
      // const aiMessageInput = document.querySelector(`.ai-message-input`);
      // console.log({ 'ai-chat-window.js:139 aiMessageInput': aiMessageInput });
      // aiMessageInput?.focus();

      // setTimeout(() => {
      //   this.scrollToNewResponse();
      //   setTimeout(() => {
      //     this.focusAIMessageInput();
      //   }, 500);
      // }, 3000);

    } catch (error) {
      if (HttpLib.isCancel(error)) {
        console.log('Request was cancelled');
      } else {
        console.error(error);
      }
    } finally {
      this.responseLoading = false;
    }

    // this.responseLoading = false;
  }

  focusAIMessageInput() {
    const aiMessageInput = document.querySelector(`.ai-message-input`);
    aiMessageInput?.focus();
  }

  scrollToNewResponse() {
    const newResponse = document.querySelector(`#ai-message-${this.newResponseId}`);
    newResponse?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    });
  }

  abortLoadResponse() {
    if (!this.source.token.reason) {
      this.source.cancel('Request cancelled');
    }
    this.responseLoading = false;

    this.messages = this.messages.map(message => {
      if (message.id === this.newResponseId) {
        return {
          ...message,
          loading: false,
          text: `Response cancelled`,
          sent: new Date().toISOString(),
          cancelled: true,
        }
      }
      return message;
    });
  }

  async mounted() {
    console.log('AIChatWindow mounted Inside');

    // const chatHistory = await AIChatService.history();
    // this.messages = createMessages(chatHistory.data);

    // console.log({ 'ai-chat-window.js:101 chatHistory': chatHistory });
  }

  async onMessageInput(value) {
    this.message = value;
  }

  async loadHistory() {
    console.log(this.moduleName);
    this.chatEnabled = true;
    this.historyEnabled = true;
    this.historyLoading = true;
    this.responseLoading = false;
    this.historyEnded = false;

    this.fetchHistory({ scrollLast: true });

    // const chatHistory = await AIChatService.history(0, this.rowCount, this.moduleName);
    // this.messages = createMessages(chatHistory.data.reverse());
    // this.historyLoading = false;

    // const count = chatHistory.data.length;
    // if (count < 100) {
    //   this.historyEnded = true;
    // }
  }

  async fetchHistory({ scrollLast } = {}) {
    this.historyLoading = true;
    const pageFirstMessage = this.messages?.[0];
    const chatHistory = await AIChatService.history(this.messages.length / 2, this.rowCount, this.moduleName);
    this.messages = [
      ...createMessages(chatHistory.data.reverse()),
      ...(this.messages || []),
    ];
    this.historyLoading = false;

    const count = chatHistory.length;
    if (count < 100) {
      this.historyEnded = true;
    }

    this.$nextTick(() => {
      if (scrollLast) {
        const aiChatThread = document.querySelector(`.ai-chat-thread`);
        aiChatThread?.scrollTo({
          top: aiChatThread.scrollHeight,
          behavior: 'smooth',
        });
      } else {
        const firstMessage = document.querySelector(`#ai-message-${pageFirstMessage?.id}`);
        firstMessage?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    });
  }
  async onScrollToTop() {
    console.log({ 'ai-chat-window.js:230 onScrollToTop': 1 });
    if (!this.historyEnabled || this.historyEnded || this.historyLoading || this.responseLoading) {
      return;
    }

    this.fetchHistory();
  }


  headerAnimationDuration = `400ms`;

  inputDisabled() {
    return this.responseLoading;
  }


  render() {
    return (
      <div class="ai-chat-window">
        {<div class="ai-chat-header"
          style={{
            height: this.chatEnabled ? '0px' : '310px',
            marginTop: this.chatEnabled ? '-38px' : '75px',
            opacity: this.chatEnabled ? '0' : '1',
            transform: this.chatEnabled ? 'scale(0.2)' : 'scale(1)',
            overflow: 'hidden',
            transition: `height ${this.headerAnimationDuration} ease-out, opacity ${this.headerAnimationDuration} ease-out, margin-top ${this.headerAnimationDuration} ease-out, transform ${this.headerAnimationDuration} ease-out`,
          }}
        >
          <div class="ai-chatbot-icon-container">
            <img
              src="static/icons/chatbot.svg"
              alt="Chatbot icon"
              class="ai-chatbot-icon"
            />
          </div>
          <h2 class="ai-chatbot-title" style={{ marginTop: "20px" }}>
            Hello, I am <img
              src="static/icons/aki2.svg"
              alt="Chatbot icon"
              class="ai-chatbot-icon"
              style={{ marginRight: "1px" }}
            />.
          </h2>
          <h2 class="ai-chatbot-title">How can I help you?</h2>
        </div>}
        <div class="ai-chat-subheader ut-flex ut-rowcen">
          {!this.historyEnabled && <button
            // style="margin: 8px; font-weight: inherit;"
            onClick={this.loadHistory}
            disabled={this.historyLoading || this.responseLoading}
            class={`dt-button v5 s8 txtov ${this.historyLoading || this.responseLoading ? 'disabled' : ''}`}
            style={{
              margin: `8px`,
              transition: `opacity 200ms ease-out`,
              opacity: this.historyLoading || this.responseLoading ? `0.4` : `1`,
            }}
          >
            <HistoryIcon />
            <span style={{ marginLeft: `2px` }}>History</span> </button>}
          {/* {this.historyEnabled && <button
            disabled={true}
            class="dt-button v5 s8 txtov disabled"
            style="opacity: 0.4; margin: 8px; font-weight: inherit;">
            <DeleteIcon />
            <span style={{ marginLeft: `2px` }}>Delete History</span> </button>}
          {this.historyEnabled && <button
            disabled={true}
            class="dt-button v5 s8 txtov disabled"
            style="opacity: 0.4; margin: 8px; font-weight: inherit;">
            <SearchIcon />
            <span style={{ marginLeft: `2px` }}>Search</span> </button>} */}
          {this.chatEnabled && <button class="dt-button v5 s8 txtov" style="margin: 8px; font-weight: inherit;"
            onClick={() => {
              this.reset();

              this.messages = [];
            }}
          >
            <ClearIcon />
            <span style={{ marginLeft: `2px` }}>Clear Chat</span>
          </button>}
        </div>
        {this.chatEnabled && <AIChatThread
          loading={this.historyLoading}
          onScrollToTop={this.onScrollToTop}
          messages={this.messages}
          onAnimationDone={() => {
            console.log({ 'ai-chat-window.js:341 onAnimationDone': 1 });
            this.scrollToNewResponse();
            this.focusAIMessageInput();
          }}
        />}
        <div class='ai-chat-thread-bottom'>
          <button class="dt-button v5 s8 txtov" style={{
            margin: `8px`,
            transition: `opacity 200ms ease-out, transform 200ms ease-out`,
            opacity: this.responseLoading ? `1` : `0`,
            transform: this.responseLoading ? `translateY(0px)` : `translateY(20px)`,
          }}
            onClick={this.abortLoadResponse}
          >
            <StopIcon />
            <span style={{ marginLeft: `2px` }}>Stop</span> </button>
        </div>
        {/* <div class="ai-chat-history">
          <div class="ai-message ai-user-message">
            <img
              src="static/icons/user.svg"
              alt="User icon"
              class="ai-message-icon"
            />
            <p>User message goes here</p>
          </div>
          <div class="ai-message ai-chatbot-message">
            <img
              src="static/icons/chatbot.svg"
              alt="Chatbot icon"
              class="ai-message-icon"
            />
            <p>Chatbot message goes here</p>
          </div>
        </div> */}
        {/* Show the Boolean Flags */}
        {/* <pre>
          {JSON.stringify({
            chatEnabled: this.chatEnabled,
            historyEnabled: this.historyEnabled,
            historyLoading: this.historyLoading,
            historyEnded: this.historyEnded,
            responseLoading: this.responseLoading,
          }, null, 2)}
        </pre> */}
        <div class="ai-chat-footer">
          <AIMessageInput msg={this.message} disabled={this.inputDisabled()} onInput={this.onMessageInput} onEnter={this.onChatSend}

          />

          <button class="ai-send-button" disabled={this.inputDisabled()} onClick={this.onChatSend}>
            <img
              src="static/icons/send-active.svg"
              style={{
                opacity: this.inputDisabled() ? `0.5` : `1`,
              }}
              alt="Send icon"
              class="ai-send-icon"
            />
          </button>
        </div>
      </div>
    );
  }
}



